/**
* 修改enjs文件后，应将修改或新增的自动同步到zh.js
* zh.js 和 en.js 字段数量应一致，如不熟悉字段使用范围，应尽量新增字段，避免修改现有字段
* **/
export default {
	common:{
		viewDetails:'查看详情',
		viewAll:'查看全部'
	},
	nav:{
		home:'首页',
		about:'关于我们',
		hxxt:'华新学堂',
		whzq:'兰亭文化专区',
		bjd:'八段锦推广计划',
		yxl:'社会影响力',
		news:'新闻中心',
		contact:'联系我们',
	},
	footer:{
		backTop:'返回顶部',
		officeAddress:'办公地址',
		adText1:'请随时与我们联系。',
		adText2:'为全球华人提供更优质、更具社会价值的服务',
		contactInfo:'联系方式：',
		websiteAddress:'官网地址：',
		companyName:'华新文化(新加坡)私人有限公司'
	},
	home:{
		bannerAd1:'传承华族文化·拥抱智能未来',
		aboutAd1:'以教育启迪未来',
		aboutAd2:'以文化连接世界',
		aboutAd3:'以公益温暖社区',
		aboutAd4:'成为具有国际影响力的教育、文化、健康与社会创新平台',
		aboutAd5:'<p>华新文化是一家立足新加坡、面向国际发展的教育、文化与社会创新机构。</p>“华新”寓意华文文化与新加坡精神的融合。',
		aboutAd6:'我们以华文文化为根，以多元共融为本，致力于通过教育、文化、健康与社会影响力四大领域的发展，推动终身学习、文化理解、身心健康与社区共融，帮助不同年龄层群体提升生活品质与未来竞争力。',
		aboutAd7:'三大课程体系',
		
		schoolItem1Title:'全球阅读力培养体系',
		schoolItem1Text:'培养阅读力、思辨力、表达力、全球视野与终身学习力。',
		schoolItem1SonTitle:'英文原版阅读中心',
		schoolItem1Tag1:'阅读能力',
		schoolItem1Tag2:'写作能力',
		schoolItem1Tag3:'批判性思维',
		schoolItem1Tag4:'演讲能力',
		
		                                       

		schoolItem2Title:'华文经典诵读体系',
		schoolItem2Text:'培养文化自信、品格修养、历史智慧、文学素养与领。',
		schoolItem2SonTitle:'华文经典诵读中心',     
		schoolItem2Tag1:'论语',
		schoolItem2Tag2:'孟子',
		schoolItem2Tag3:'大学',
		schoolItem2Tag4:'中庸',
		schoolItem2Tag5:'诗词经典',
		
		
		schoolItem3Title:'未来教育体系',
		schoolItem3Text:'培养AI素养、数字公民意识、未来适应力与创新能力。',
		schoolItem3SonTitle:'未来教育中心',
		schoolItem3Tag1:'青少年课程',
		schoolItem3Tag2:'家长课程',
		schoolItem3Tag3:'长者课程',
		
		block1Ad1:'公益项目',
		block1Ad2:'社区慈善馈赠计划',
		block1Tag1:'培养数字导师',
		block1Tag2:'社区志愿者',
		block1Tag3:'青年公益领袖',
		block1Tag4:'公益推广大使',
		block1Text:'公司及创始人冯婷婷女士长期参与新加坡社区公益活动，通过持续捐赠及公益合作项目支持社区发展、终身教育及数字包容。',
		
		block2Ad1:'兰亭文化',
		block2Ad2:'通过文化交流、文化体验活动、国际合作项目及文化大使培养，帮助不同背景的人们认识华文文化传统，理解华族文明所承载的人文价值。',
		
		newsUpdates:'新闻动态'
		
	},
	about:{
		fixNav1:'公司介绍',
		fixNav2:'创始人介绍',
		fixNav3:'来自创始人的信',
		
		company:'公司简介',
		aboutText1:'<div class="aboutBoxTitle"><p>华新文化是一家立足新加坡、面向国际发展的教育、文化与社会创新机构。</p><p>“华新”寓意华文文化与新加坡精神的融合。</p></div><div class="aboutBoxText">我们以华文文化为根，以多元共融为本，致力于通过教育、文化、健康与社会影响力四大领域的发展，推动终身学习、文化理解、身心健康与社区共融，帮助不同年龄层群体提升生活品质与未来竞争力。我们相信：<br/>以教育启迪未来<br/>以文化连接世界<br/>以健康促进幸福<br/>以公益温暖社区<br/>通过跨领域合作与社会创新，打造具有国际视野、人文关怀与社会责任感的学习型平台。</div>',
		
		vision:'愿景',
		visionText:'成为具有国际影响力的教育、文化、健康与社会创新平台。连接文化根源，促进文明交流，培养面向未来的世界公民。',
		
		mission:'使命',
		missionText:'培养具有全球视野、文化自信、健康生活方式与社会责任感的未来公民。',
		
		values:'价值观',
		valuesText:'终身学习<br/>文化传承<br/>身心健康<br/>社会关怀<br/>创新发展',
		
		
		ceoAbout:'创始人介绍',
		
		aboutFounder:'<div class="aboutBoxTitle">关于创始人</div>'+
			'<div class="aboutBoxText">'+
				'<p>冯婷婷女士是华新文化（新加坡）私人有限公司创始人，长期致力于教育、文化交流、国际合作及社区公益事业。</p>'+
				'<p>怀着对中华文化的热爱和对新加坡多元文化社会的认同，她于2025年在新加坡创立华新文化，希望以新加坡作为连接中国与世界的重要桥梁，促进教育交流、文化互鉴及社区融合。</p>'+
				'<p>她相信，文化能够连接不同国家和不同族群，教育能够改变个人与家庭的未来，而公益能够让社会更加温暖和包容。</p>'+
			'</div>'+
			'<br />'+
			'<div class="aboutBoxTitle">'+
				'创业理念'+
			'</div>'+
			'<div class="aboutBoxText">'+
				'<p>在全球化快速发展的今天，越来越多华人家庭希望获得国际化教育资源，也希望在保留中华文化根基的同时，更好地融入所在国家。</p>'+
				'<p>冯婷婷女士创办华新文化，正是希望依托新加坡优质教育体系、多元文化环境及国际化优势，打造一个融合教育、文化、公益与科技的综合平台，为本地居民及全球华人提供更优质、更具社会价值的服务</p>'+
			'</div>'+
			'<br />'+
			'<div class="aboutBoxTitle">'+
				'社会责任'+
			'</div>'+
			'<div class="aboutBoxText">'+
				'<p>冯婷婷女士始终坚持：<br/>企业的发展不仅追求商业价值，更应承担社会责任。</p>'+
				'<p>近年来，她积极支持新加坡社区公益事业，并带领华新文化持续参与公益项目，与社区机构合作推广乐龄人士数字教育、人工智能普及及健康生活理念，希望通过教育与科技帮助更多居民共享数字时代的发展成果。</p>'+
				'<p>未来，公司还将通过AI数字内容推广中华传统养生文化，如八段锦、太极、国学经典阅读等，推动健康生活方式和中华优秀传统文化在新加坡社区的传播。</p>'+
			'</div>'+
			'<br />'+
			'<div class="aboutBoxTitle">'+
				'对未来的愿景'+
			'</div>'+
			'<div class="aboutBoxText">'+
				'<p>冯婷婷女士希望华新文化能够成为：</p>'+
				'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>新加坡与中国教育文化交流的重要桥梁；</div>'+
				'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>推动双语教育及中华文化传播的平台；</div>'+
				'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>服务社区、促进社会融合的公益企业；</div>'+
				'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>利用人工智能传播健康教育与传统文化的创新实践者。</div>'+
			'</div>'+
			'<br />'+
			'<div class="aboutBoxTitle">'+
				'她相信：'+
			'</div>'+
			'<div class="aboutBoxText">'+
				'教育连接未来，文化连接世界，公益连接人心。'+
			'</div>',
		
		
		
		
	},
	school:{
		ad1:'华新文化旗下教育品牌',
		ad2:'看世界 · 懂华文 · 向未来',
		sonTitle:'三大课程体系'
	},
	special:{
		sonTitle:'六大核心项目',
		aboutText:'以促进文化理解与文明交流为使命。<br/>通过文化交流、文化体验活动、国际合作项目及文化大使培养，帮助不同背景的人们认识华文文化传统，理解华族文明所承载的人文价值。',
		
		item1Title:'海外传播基地',
		item1SonTitle:'兰亭文化的世界发声窗口',
		item1Text:'兰亭文化国际化传播枢纽、中外书法文化交流中枢、中华文化出海标杆平台，打通兰亭文化海外传播全渠道，让兰亭笔墨成为世界读懂中华雅致文化的核心符号。',
		
		item2Title:'兰亭雅集',
		item2SonTitle:'古今共生的国风文化盛宴',
		item2Text:'复刻永和雅集千古意境，打造常态化、精品化、沉浸式的顶级国风文化IP，传承文人雅韵，活化传统文人生活美学。',
		
		item3Title:'兰亭少年计划',
		item3SonTitle:'文脉传承的新生力量培育工程',
		item3Text:'兰亭文化青少年传承培育体系，深耕少儿书法美育，播种传统文化种子，培育新时代兰亭文脉传承人。',
		
		item4Title:'兰亭家庭计划',
		item4SonTitle:'全民共享的生活化文化场景',
		item4Text:'轻量化、亲民化、常态化的全民文化体验项目，推动兰亭文化走进家庭、融入日常，实现传统文化全民普及。',
		
		item5Title:'兰亭国际展',
		item5SonTitle:'跨界融合的艺术展示高地',
		item5Text:'国际性、开放性、创新性的书法艺术展示平台，汇聚全球书画力量，打造兰亭艺术标杆展览IP。',
		
		item6Title:'兰亭国际研学',
		item6SonTitle:'知行合一的文化研学标杆',
		item6Text:'国际化、精品化、体系化的文化研学品牌，打造国内顶尖、面向国际的兰亭书法文化研学目的地。'
	},
	promotion:{
		sonTitle:'四大板块',
		sonTitle2:'每天8分钟，让健康成为习惯',
		ad1:'推广华族传统养生智慧。<br/>通过八段锦教学、健康讲座、社区活动及企业健康项目，促进身心健康与积极生活方式。',
		
		
		item1Title:'社区健康',
		item1SonTitle:'扎根基层的全民康养阵地',
		item1Text:'社区全民普及核心场景，覆盖全年龄段居民，打造家门口的免费康养健身课堂，构建邻里健康生活新风尚。',
		
		item2Title:'职场健康',
		item2SonTitle:'适配职场人的轻解压运动方案',
		item2Text:'针对职场亚健康痛点，打造轻量化、碎片化的职场解压康养运动，解决久坐劳损、肩颈僵硬、身心疲惫、专注力不足等职场健康问题。',
		
		item3Title:'校园健康',
		item3SonTitle:'青少年身心素养培育载体',
		item3Text:'适配中小学、高校师生群体，以八段锦强健青少年体魄、舒缓学业压力、涵养心性气质，打造校园特色体育美育融合项目。',
		
		item4Title:'银发康养',
		item4SonTitle:'中老年专属科学康养体系',
		item4Text:'版块定位：适配中老年、银发群体身体机能特点，打造温和、安全、科学的康养运动，助力慢病调理、强身健体、延年益寿，丰富老年康养生活。',
		
		
	},
	influence:{
		sonTitle:'华新文化积极推动社区公益与社会责任建设。',
		
		item1Title:'金色年华数字乐龄公益支持计划',
		item1Text:'华新文化作为公益支持伙伴，长期支持金色年华基金会开展乐龄数字素养教育项目，并重点支持Digital Buddy志愿者体系建设，通过资助志愿者发展与社区参与，促进数字包容与积极老龄化。',
		
		item2Title:'社区慈善捐赠计划',
		item2Text:'<div>长期支持：</div><div class="yxlTextList">HWA（残障人士福利协会）</div><div class="yxlTextList">SACS（新加坡圣公会社区服务）</div><div class="yxlTextList">SAMH（圣安德烈教会医院）</div><div >坚持每月定期公益捐赠</div>',
		
		item3Title:'青年志愿者发展计划',
		item3Text:'培养数字导师、社区志愿者、青年公益领袖及公益推广大使。'
	},
	news:{
		allNews:'全部新闻'
	},
	contact:{
		sonTitle:'期待与您的联系',
		officeAddress:'办公地址：',
		contactInformation:'联系方式：',
		email:'电子邮箱：',
		webSite:'官方网站：'
	}
}
